import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-59d3cd00"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "block"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("InvestNFT");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("Share Value to Grow ");

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_8 = /*#__PURE__*/_createTextVNode("Stronger Together");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" InvestNFT connects different NFT projects to enable collaborative value assurance. ");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("Contact Us");

const _hoisted_11 = {
  class: "entry-container"
};
const _hoisted_12 = ["onMouseenter", "onClick"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "front"
};
const _hoisted_16 = {
  class: "font-h5 sub-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_content_text = _resolveComponent("content-text");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_content_text, {
    url: "mailto:support@investnft.finance"
  }, {
    title: _withCtx(() => [_hoisted_5]),
    subtitle: _withCtx(() => [_hoisted_6, _hoisted_7, _hoisted_8]),
    content: _withCtx(() => [_hoisted_9]),
    button: _withCtx(() => [_hoisted_10]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.entries, (entry, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: entry.name,
      class: _normalizeClass(["entry-wrapper", {
        open: $data.expandEntry === index
      }]),
      onMouseenter: $event => this.expandEntry = index,
      onClick: $event => $options.goRoute(entry)
    }, [_createElementVNode("img", {
      src: entry.img,
      alt: "entry",
      class: "mobile-hidden"
    }, null, 8, _hoisted_13), _createElementVNode("img", {
      src: entry.imgMobile,
      alt: "entry",
      class: "mobile-only"
    }, null, 8, _hoisted_14), _createElementVNode("div", _hoisted_15, [_createElementVNode("h5", _hoisted_16, _toDisplayString(entry.name), 1)])], 42, _hoisted_12);
  }), 128))])])]);
}